module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.tagConfig),
      callback: function($$v) {
        _vm.tagConfig = $$v
      },
      expression: "tagConfig"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-cadastro"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-list-alt"
  }), _vm._v(" Informações Cadastrais")]), _vm._v(" "), _c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.parceiroItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  })])], 1), _vm._v(" "), (_vm.formData.id > 0) ? _c('el-tab-pane', {
    attrs: {
      "label": "Fator de Risco desse Laboratório",
      "name": "tab-exames"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  }), _vm._v(" Fator de Risco desse Laboratório")]), _vm._v(" "), _c('FatorRisco', {
    attrs: {
      "laboratorio": _vm.formData
    }
  })], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a557ff38"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/web/ltcat/laboratorio/editar.vue
// module id = 1579
// module chunks = 45